import { Placeholder } from 'rsuite';

const Skeleton = () => (
	<div className="flex flex-col h-full w-full gap-[16px] items-center justify-center">
		<div className='flex flex-1 w-full gap-[16px] items-center'>
			<Placeholder.Graph
				active
				className="!w-[24px] !h-[24px] !min-w-[24px] rounded-full"
			/>
			<div className='flex w-full items-center justify-between'>
				<Placeholder.Graph
					active
					className="!w-[120px] !h-[12px]"
				/>
				<Placeholder.Graph
					active
					className="!w-[60px] !h-[10px]"
				/>
			</div>
		</div>
		<div className='flex flex-1 w-full justify-between gap-[16px]'>
			<Placeholder.Paragraph
				rows={2}
				active
				className="!w-full !h-[48px]"
			/>
			<Placeholder.Graph
				active
				className="!w-[16px] !h-[16px] rounded-[4px]"
			/>
		</div>
	</div>
);

export default Skeleton;
